(function () {
    'use strict';

    angular
        .module('nagarpalika', ['ngMaterial','ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'toastr', 'ui-notification', 'pascalprecht.translate', 'angular-sortable-view','slick']);

})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('ServiceslistController', ['$http','appConfig','$stateParams',ServiceslistController]);

  /** @ngInject */
  function ServiceslistController($http,appConfig,$stateParams) {
    var vm = this
    vm.serviceid = $stateParams.serviceid;
    vm.aboutcontent = {};
    var alldata = { "servicename": vm.serviceid };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'serviceslist.php',
      data: alldata
    }).then(function (data) {
      vm.aboutcontent = data.data.data;
      console.log(vm.aboutcontent);
    }, function (e) {
      // console.log(e);
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('ServicesController', ['$http','appConfig',ServicesController]);

  /** @ngInject */
  function ServicesController($http,appConfig) {
    var vm = this
    vm.servtab = {};
    
        $http.get(appConfig.BASE_URL+'citiservies.php').then(function (data) {
          vm.servtab = data.data.data;
          //console.log(members);
        }, function (e) {
          console.log(e);
        });

  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('RtiController', ['$http','appConfig',RtiController]);

  /** @ngInject */
  function RtiController($http,appConfig) {
    var vm = this
    vm.rtiinfo = {};
    $http.get(appConfig.BASE_URL+'rti.php').then(function (data) {
      vm.rtiinfo = data.data.data;
      
    }, function (e) {
      console.log(e);
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('NewslistController', ['$http','appConfig','$stateParams',NewslistController]);

  /** @ngInject */
  function NewslistController($http,appConfig,$stateParams) {
    var vm = this;
    vm.newsid = $stateParams.newsid;
    vm.aboutcontent = {};
    var alldata = { "newsid": vm.newsid };
   
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'newslist.php',
      data: alldata
    }).then(function (data) {
      vm.aboutcontent = data.data.data;
     
    }, function (e) {
      // console.log(e);
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('NewsController', [NewsController]);

  /** @ngInject */
  function NewsController() {
    var vm = this;


  }
})();

(function () {
  'use strict';
  angular
    .module('nagarpalika')
    .controller('homeController', ['$state', '$http', 'appConfig', homeController]);

  /** @ngInject */
  function homeController($state, $http, appConfig) {
    var vm = this
    vm.category_block = [
      { text: 'program', state: 'program', id: '1' },
      { text: 'school term dates', state: 'school-trem-dates', id: '2' },
      { text: 'about nagarpalika', state: 'nagarpalika', id: '3' },
      { text: 'benefits', state: 'benefits', id: '4' },
      { text: 'about nagarpalika', state: 'nagarpalika', id: '3' },
      { text: 'benefits', state: 'benefits', id: '4' }
    ];
   
    vm.resdata = {};
    var alldata = { "type": "welcome" };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'content.php',
      data: alldata
    }).then(function (data) {
      vm.resdata = data.data.data;
    }, function (e) {
      // console.log(e);
    });

    vm.chnagePage = function () {
      $state.go("login");
    }






  };

})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('InfoController', ['$http','appConfig',InfoController]);

  /** @ngInject */
  function InfoController($http,appConfig) {
    var vm = this
    vm.title = 'Contact';
    vm.depinfo = {};
    $http.get(appConfig.BASE_URL+'department.php').then(function (data) {
      vm.depinfo = data.data.data;
      
    }, function (e) {
      console.log(e);
    });

  }
})();
(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('GalleryController', ['$http','appConfig','UtilService',GalleryController]);

  /** @ngInject */
  function GalleryController($http,appConfig,UtilService) {
    var vm = this;
    vm.galdata = {};
    
    $http.get(appConfig.BASE_URL+'gallery.php').then(function (data) {
      vm.galdata = data.data.data;

    }, function (e) {
      console.log(e);
    });

   
    // var data = {"url": "gallery/gallery.html",
    //             "ctrl": "GalleryController",
    //             "event":"",
    //             "clickToCloseOutSide":true,
    //             dataParams:null
    //             };
    
    vm.showImage = function(event,img){
      var data = {"url": "imagegallery/imagegallery.html",
      //"ctrl": "ImgController",
      "event":event,
      "clickToCloseOutSide":true,
      dataParams:{"image":img}
      };
      UtilService.customDialog(data);
    }



  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('DownController', ['$http','appConfig',DownController]);

  /** @ngInject */
  function DownController($http,appConfig) {
    var vm = this
    vm.dwiteams = {};
    $http.get(appConfig.BASE_URL+'downloads.php').then(function (data) {
    vm.dwiteams = data.data.data;
    //console.log(members);
    }, function (e) {
    console.log(e);
    });


  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('DevelopmentController', ['$http','appConfig',DevelopmentController]);

  /** @ngInject */
  function DevelopmentController($http,appConfig) {
    var vm = this
    vm.devprg = {};
    $http.get(appConfig.BASE_URL+'programs.php').then(function (data) {
      vm.devprg = data.data.data;
      console.log(listnews);
    }, function (e) {
      console.log(e);
    });





  }
})();

(function () {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('ContactController', ['$http', 'appConfig', 'UtilService', ContactController]);

  /** @ngInject */
  function ContactController($http, appConfig, UtilService) {
    var vm = this;
    vm.RecptchaKey = appConfig.RecptchaKey;
    console.log(appConfig.RecptchaKey);



    vm.formData = {};
    vm.contdata = {};




    $http.get(appConfig.BASE_URL + 'contactdata.php').then(function (data) {
      vm.contdata = data.data.data;
    }, function (e) {
      console.log(e);
    });
    
    vm.links = {};
    // social links
    $http.get(appConfig.BASE_URL+'sociallinks.php').then(function (data) {
      vm.links = data.data.data;
      //console.log(members);
  }, function (e) {
      console.log(e);
  });
    // vm.myCode = function(){
    //   alert('heelo');
    // } 
   
    
    vm.getRandomSpan = function() {
      vm.rNum = Math.floor((Math.random() * 10000) + 1);
    };
    vm.getRandomSpan();
   
    vm.contactForm = function () {
      var alldata = vm.formData;
      if (vm.formData.cbox == true) {
        if (vm.formData.captcha == vm.rNum) {
          $http({
            method: 'POST',
            url: appConfig.BASE_URL + 'contact.php',
            data: alldata
          }).then(function (data) {
            if (data.data.status == true) {
              //alert("data inserted");
              UtilService.showToast('Thanks For Contacting : We will get back to you.', 'bottom right');
              vm.formData.subject = '';
              vm.formData.name = '';
              vm.formData.email = '';
              vm.formData.mobile = '';
              vm.formData.message = '';
            }
            else {
              //alert("data not inserted");
              UtilService.showToast('Error in posting form : Please check.', 'bottom right');

            }
          }, function (e) {
            console.log(e);
          });
        }
        else {
          UtilService.showToast('Entered code not found.', 'bottom right');
        }
      }
      else {
        UtilService.showToast('Please check given box.', 'bottom right');
      }


    }


  }
})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('AboutController', ['$http','appConfig',AboutController]);

  /** @ngInject */
  function AboutController($http,appConfig) {
    var vm = this;

    vm.aboutcontent = {};
    var alldata = { "type": "welcome" };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'content.php',
      data: alldata
    }).then(function (data) {
      vm.aboutcontent = data.data.data;
      
    }, function (e) {
      // console.log(e);
    });

    vm.cityInfo = {};
    var alldata2 = { "type": "cityinformation" };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'content.php',
      data: alldata2
    }).then(function (data) {
      vm.cityInfo = data.data.data;
     
    }, function (e) {
      // console.log(e);
    });

    vm.mmessage = {};
    var alldata3 = { "type": "messages" };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'content.php',
      data: alldata3
    }).then(function (data) {
      vm.mmessage = data.data.data;
     
    }, function (e) {
      // console.log(e);
    });

    vm.cmessage = {};
    var alldata4 = { "type": "cmessage" };
    $http({
      method: 'POST',
      url: appConfig.BASE_URL+'content.php',
      data: alldata4
    }).then(function (data) {
      vm.cmessage = data.data.data;
     
    }, function (e) {
      // console.log(e);
    });


  }
})();

;(function () {
  'use strict'
  angular.module('nagarpalika').factory('sliderService', ['$q', '$http' ,'appConfig',sliderService]);

  function sliderService ($q, $http, appConfig) {
    var sliderImages = [
      {img: 'slider1.jpg', id: '1'},
      {img: 'slider3.jpg', id: '2'},
      {img: 'slider4.jpg', id: '3'}
    ];
    //var sliderImages = [];
    return {
      silderImageService: function () {
        return $q(function (resolve, reject) {
          if (sliderImages.length) {
            resolve(sliderImages);
          }else {
            // sliderImages = 'not found';
            // reject(sliderImages);

            $http.get(appConfig.BASE_URL+'slider.php').then(function(data){
              sliderImages = data.data.data;
              resolve(sliderImages)
             
              },function(e){
              //console.log(e);
              reject(sliderImages);
              });

          }
        })
      }//silderImageService
    }//return
  }//sliderService
}());

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('appSlider', ['$q', appSlider]);

  /** @ngInject */
  function appSlider($q) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/slider/slider.html',
      scope: {
      },
      controller: SliderCtrl,
      controllerAs: 'slider',
      bindToController: true
    }
    return directive;
  }//appSlider

  /** @ngInject */
  function SliderCtrl($scope, $location, appConfig, sliderService) {
    var vm = this
    vm.prevArrow = "<button class='fa fa-angle-left' type='button'></button";
    vm.nextArrow = "<button class='fa fa-angle-right' type='button'></button";
    vm.localimagesPath = appConfig.localImgPath;
    
    vm.sliderImg = [];

    sliderService.silderImageService()
      .then(function (res) {
        vm.sliderImg = res;
        console.log(vm.sliderImg);
      });
  }//SliderCtrl

})();

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('servicesTab', ['$http','appConfig',servicesTab])
  /** @ngInject */
  function servicesTab() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/services/services.html',
      scope: {
      },
      controller: servicesCtrl,
      controllerAs: 'serve',
      bindToController: true
    }
    return directive
  }//myHeader

  /** @ngInject */
  function servicesCtrl($scope,$http,appConfig) {
    var vm = this;
    vm.servtab = {};

    $http.get(appConfig.BASE_URL+'citiservies.php').then(function (data) {
      vm.servtab = data.data.data;
      //console.log(members);
    }, function (e) {
      console.log(e);
    });

  }//HeaderCtrl

})();

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('otherLinks', [otherLinks])
  /** @ngInject */
  function otherLinks() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/otherlinks/otherlinks.html',
      scope: {
      },
      controller: otherLinksCtrl,
      controllerAs: 'ol',
      bindToController: true
    }
    return directive
  }//myHeader

  /** @ngInject */
  function otherLinksCtrl($scope,$http,appConfig) {
    var vm = this
    vm.otherlinks = {};
      $http.get(appConfig.BASE_URL+'citiservies.php').then(function (data) {
        vm.otherlinks = data.data.data;
        console.log(vm.otherlinks);
      }, function (e) {
        console.log(e);
      });
    
  }//HeaderCtrl

})();

/*globals*/
(function () {
  'use strict';

  angular
    .module('nagarpalika')
    .directive('newsLetter', [newsLetter]);

  /** @ngInject */
  function newsLetter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/newsletter/newsletter.html',
      scope: {
      },
      controller: NewsLetterCtrl,
      controllerAs: 'nlc',
      bindToController: true
    }

    return directive;
  }//newsLetter

  /** @ngInject */
  function NewsLetterCtrl(appConfig) {
    var vm = this
    vm.localimagesPath = appConfig.localImgPath
   
  }//NewsLetterCtrl

})();

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('latestNews', ['$http','appConfig',latestNews])
  /** @ngInject */
  function latestNews() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/latestnews/latestnews.html',
      scope: {
      },
      controller: latestNewsCtrl,
      controllerAs: 'ln',
      bindToController: true
    }
    return directive
  }//myHeader

  /** @ngInject */
  function latestNewsCtrl($scope,$http,appConfig) {
    var vm = this
    
    vm.listnews = {};
    $http.get(appConfig.BASE_URL+'latestnews.php').then(function (data) {
      vm.listnews = data.data.data;
      
    }, function (e) {
      console.log(e);
    });
    
  }//HeaderCtrl

})();

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('impLinks', ['$http','appConfig',impLinks])
  /** @ngInject */
  function impLinks() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/implinks/implinks.html',
      scope: {
      },
      controller: impLinksCtrl,
      controllerAs: 'impl',
      bindToController: true
    }
    return directive
  }//myHeader

  /** @ngInject */
  function impLinksCtrl($scope,$http,appConfig) {
    var vm = this;
    vm.links = {};
    $http.get(appConfig.BASE_URL+'implinks.php').then(function (data) {
      vm.links = data.data.data;
      //console.log(members);
    }, function (e) {
      console.log(e);
    });
  }//HeaderCtrl

})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .controller('ImgController', ['$http','appConfig','UtilService',ImgController]);

  /** @ngInject */
  function ImgController($http,appConfig,UtilService) {
    var vm = this;
    vm.galdata = {};
    
    $http.get(appConfig.BASE_URL+'gallery.php').then(function (data) {
      vm.galdata = data.data.data;
      console.log(listnews);
    }, function (e) {
      console.log(e);
    });




  }
})();

(function () {
  'use strict'

  angular.module('nagarpalika').factory('mainMenu', ['$q','$http','appConfig', mainMenu]);
  
  function mainMenu ($q,$http,appConfig) {

        //var menuDetails = {};//[
                        //     {text: 'Home', state: 'main'},
                        //     {text: 'About us', state: 'about'},
                        //     {text: 'Citizen Services', state: 'services'},
                        //     {text: 'City Development Programs', state: 'development'},
                        //     {text: 'RTI', state: 'rti'},
                        //     {text: 'Department Information', state: 'information'},
                        //     {text: 'News', state: 'news'},
                        //     {text: 'Gallery', state: 'gallery'},
                        //     {text: 'Downloads', state: 'downloads'},
                        //     {text: 'Contact us', state: 'contact'},
                        // ];
    var menuDetails = [];

    return {
        menuService: function(){
            return $q(function(resolve, reject){
                if(menuDetails.length){
                    resolve(menuDetails)
                }
                else{
                    $http.get(appConfig.BASE_URL+'menu.php').then(function(data){
                        menuDetails = data.data.data;
                        resolve(menuDetails)
                        //console.log(menuDetails);
                        },function(e){
                        //console.log(e);
                        reject(menuDetails);
                        });
                    
                }
            })
        }
    }
  }
}());

/*globals*/
; (function () {
    'use strict'
  
    angular
      .module('nagarpalika')
      .directive('myHeader', [myHeader])
      .directive('sidenavPushIn', function () {
          return {
              restrict: 'A',
              require: '^mdSidenav',
              link: function ($scope, element, attr, sidenavCtrl) {
                  var body = angular.element(document.body);
                  body.addClass('md-sidenav-push-in');
                  var cssClass = (element.hasClass('md-sidenav-left') ? 'md-sidenav-left' : 'md-sidenav-right') + '-open';
                  var stateChanged = function (state) {
                      body[state ? 'addClass' : 'removeClass'](cssClass);
                  };
                  // overvwrite default functions and forward current state to custom function
                  angular.forEach(['open', 'close', 'toggle'], function (fn) {
                      var org = sidenavCtrl[fn];
                      sidenavCtrl[fn] = function () {
                          var res = org.apply(sidenavCtrl, arguments);
                          stateChanged(sidenavCtrl.isOpen());
                          return res;
                      };
                  });
              }
          };
      });
  
  
    /** @ngInject */
    function myHeader() {
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/header/header.html',
        scope: {
        },
        controller: HeaderCtrl,
        controllerAs: 'hc',
        bindToController: true
      }
      return directive
    }//myHeader
  
    /** @ngInject */
    function HeaderCtrl($scope, $location, appConfig, mainMenu, $mdSidenav, $http) {
        var vm = this;
        vm.menuInfo = [];
        vm.datetoday = Date.now();
        vm.localimagesPath = appConfig.localImgPath;
        vm.members = {};
        vm.links = {};
        vm.logoimage = {};
        // header members
        $http.get(appConfig.BASE_URL+'members.php').then(function (data) {
            vm.members = data.data.data;
            //console.log(members);
        }, function (e) {
            console.log(e);
        });
        // social links
        $http.get(appConfig.BASE_URL+'sociallinks.php').then(function (data) {
            vm.links = data.data.data;
            //console.log(members);
        }, function (e) {
            console.log(e);
        });

        // 

        $http.get(appConfig.BASE_URL+'logoimage.php').then(function (data) {
            vm.logoimage = data.data.data;
            //console.log(members);
        }, function (e) {
            console.log(e);
        });
        


      vm.toggleSidenav = function () {
       $mdSidenav('nav').toggle();
      };
      vm.toggleMenu = function (){
          $mdSidenav('nav').toggle();
           //vm.isToggleMenuActive = ( vm.isToggleMenuActive == true) ? false: true;
      }
      mainMenu.menuService()
        .then(function (res) {
          vm.menuInfo = res;
        });

       
    }//HeaderCtrl
  
  })();
/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('myFooter', [myFooter]);

  /** @ngInject */
  function myFooter() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
      },
      controller: FooterCtrl,
      controllerAs: 'fc',
      bindToController: true
    }
    return directive
  }//myFooter

  /** @ngInject */
  function FooterCtrl(appConfig, mainMenu, $http) {
    var vm = this
    vm.menuInfo = [];
    vm.contdata ={};
    vm.flink = [
              {
                "id":"1",
                "name":"Downloads",
                "url":"downloads"
              },
              {
                "id":"2",
                "name":"RTI",
                "url":"rti"
              },
              {
                "id":"1",
                "name":"News",
                "url":"news"
              },
              {
                "id":"1",
                "name":"Department",
                "url":"information"
              }];
       vm.qlink = [
              {
                "id":"1",
                "name":"Water Bill",
                "url":""
              },
              {
                "id":"1",
                "name":"Tender",
                "url":""
              },
              {
                "id":"1",
                "name":"Street Details",
                "url":""
              },
              {
                "id":"1",
                "name":"Online Billing",
                "url":""
              }];
       vm.mlink = {};
       vm.links = {};

       $http.get(appConfig.BASE_URL+'contactdata.php').then(function (data) {
        vm.contdata = data.data.data;
      }, function (e) {
        console.log(e);
      });

      $http.get(appConfig.BASE_URL+'sociallinks.php').then(function (data) {
        vm.links = data.data.data;
        //console.log(members);
    }, function (e) {
        console.log(e);
    });

    vm.localimagesPath = appConfig.localImgPath
    mainMenu.menuService()
      .then(function (res) {
        vm.mlink = res;
      });

      
  }//FooterCtrl
  
})();

/*globals*/
(function () {
  'use strict';

  angular
    .module('nagarpalika')
    .directive('followUs', ['$q', followUs]);

  /** @ngInject */
  function followUs($q) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/follow-us/followus.html',
      scope: {
      },
      controller: followUsCtrl,
      controllerAs: 'fuc',
      bindToController: true
    }

    return directive;
  }//followUs

  /** @ngInject */
  function followUsCtrl(appConfig) {
    var vm = this
    vm.menuInfo = [];
    vm.localimagesPath = appConfig.localImgPath
   
  }//followUsCtrl

})();

/*globals*/
; (function () {
  'use strict'

  angular
    .module('nagarpalika')
    .directive('devWork', [devWork])
  /** @ngInject */
  function devWork() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/devwork/devwork.html',
      scope: {
      },
      controller: devWorkCtrl,
      controllerAs: 'dw',
      bindToController: true
    }
    return directive
  }//myHeader

  /** @ngInject */
  function devWorkCtrl($scope,$http,appConfig) {
    var vm = this;
    //var cont1 = 'Nullam vestibulum ligula id tellus pretium, in iaculis diam tempus. Vestibulum euismod varius sapien. Maecenas viverra cursus eros. Nam quis pulvinar ex. Nullam non nulla congue, pharetra mi sed, viverra sapien. Suspendisse tristique magna pretium mi varius, eget tristique justo malesuada.';
    // vm.devcont = [{"title":"Roads Repairing","id":"1","image":"assets/images/bg_img.jpg","content":cont1},
    //             {"title":"Construction of public toilets","id":"1","image":"assets/images/bg_img.jpg","content":cont1},
    //           {"title":"Park Cleaning","id":"1","image":"assets/images/bg_img.jpg","content":cont1}];
    vm.devcont = {};   
    $http.get(appConfig.BASE_URL+'programs.php').then(function (data) {
        vm.devcont = data.data.data;
      
    }, function (e) {
        console.log(e);
    });

  }//HeaderCtrl

})();

(function () {
  'use strict';
  angular.module('nagarpalika').factory('UtilService', ['$mdDialog', '$mdMedia', 'appConfig', '$log', '$document', '$mdToast', '$q', appDialog])

  function appDialog($mdDialog, $mdMedia, appConfig, $log, $document, $mdToast, $q) {
    return {
      customDialog: function (data) {
        //data = {"url": "login-dialog/login-dialog.html", "ctrl": "LoginCtrl","event":"","clickToCloseOutSide":false,dataParams:null};
        if (data.event == undefined) {
          data.event = null;
        }
        $mdDialog.show({
          controller: ['$rootScope','$scope', 'items', function ($rootScope, $scope, items) {
            $scope.params = items;     
            console.log($scope.params);    
            this.closeLogin = function () {
              $mdDialog.hide();
            }         
          }], //data.ctrl,
          controllerAs: 'dc',
          templateUrl: appConfig.componentUrl + data.url,
          parent: angular.element($document.body),
          targetEvent: data.event,
          clickOutsideToClose: data.clickToCloseOutSide,
          locals: {
            items: data.dataParams || null
          }
        }).then(function (answer) {
          $log.log('You said the information was "' + answer + '".');
        }, function () {
          $log.log('You cancelled the dialog.');
        })
      },
      alertDialog: function (alertParams) {
        //alertParams={"title":"","content":"","ok":"","ev":"","ok":"","label":""}
        if (alertParams.ev == undefined) {
          alertParams.ev = null;
        }
        if (alertParams.ok == undefined) {
          alertParams.ok = 'ok';
        }
        $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element($document.body))
          .clickOutsideToClose(true)
          .title(alertParams.title)
          .textContent(alertParams.content)
          .ariaLabel(alertParams.label)
          .ok(alertParams.ok)
          .targetEvent(alertParams.ev)
        );
      },
      close: function () {
        $mdDialog.hide();
      }, //close

      /**
       * params:{title:"",textContent:"",placeholder:""}
       */
      showPrompt: function (ev, params) {
        return $q(function (resolve, reject) {
          // Appending dialog to document.body to cover sidenav in docs app
          var confirm = $mdDialog.prompt()
            .title(params.title)
            .textContent(params.textContent)
            .placeholder(params.placeholder)
            .ariaLabel(params.placeholder)
            .initialValue()
            .targetEvent(ev)
            .ok('Submit')
            .cancel('cancel');
          $mdDialog.show(confirm).then(function (result) {
            resolve(result);
          }, function () {
            reject(false);
          });
        })
      }, //showPrompt

      showToast: function (msg,pos) {
        pos = (pos==undefined)?'top right':pos;
        $mdToast.show(
          $mdToast.simple()
          .textContent(msg)
          .position(pos)
          //.parent(document.querySelectorAll('body'))          
          //.hideDelay(false)
          //.action('x')
        );
      } //showtoast


    } //return
  }
})();

/*globals _*/
(function () {
    'use strict';
    
    angular.module('nagarpalika').factory('RestService', ['$q','$http','$window','appConfig','config',RestService]);
    /** @ngInject */
    function RestService($q,$http,$window,appConfig,config) {
        /**
         * This function encapsulates making a RESTful request to a specific API route (op)
         *
         * @param url ,  op
         * @returns {{}}
         * @constructor
         */
        console.log(appConfig.BASE_URL);
        return {
            post: function (url,params) {
                return $q(function (resolve, reject) {
                    $http({
                        method: 'POST',
                        url: appConfig.BASE_URL + ''+url,
                        data: params
                    }).then(function success(response) {
                        if (response.data.status == 1) {
                            resolve(response.data);
                        } else {
                            console.log(JSON.stringify(response));
                            reject(response.data);
                        }
                    }, function error(response) {
                        console.log(JSON.stringify(response));
                        reject(response.data);
                    });
                });
            },//post

            uploadFile: function(){

            }//uploadFile

        }

    }

})();
/*globals _*/
;(function () {
  'use strict'

  angular.module('nagarpalika').factory('AuthService', ['$q','$http','appConfig',AuthService]);

  /** @ngInject */
  function AuthService ($q,$http,appConfig) {
    return {
      autoLogin: function () {
        var isLog = localStorage.getItem('isLogedIn') || 0
        $rootScope.userDetails = JSON.parse(localStorage.getItem('userDetails')) || null
        $rootScope.isLogedIn = isLog
        return isLog
      },

      login: function (params) {
        return $q(function (resolve, reject) {
          $http({
            method: 'POST',
            url: appConfig.BASE_URL + 'userLogin',
            data: params
          }).then(function success (response) {
            if (response.data.status == 1) {
              $rootScope.userDetails = response.data.response
              $rootScope.isLogedIn = 1
              localStorage.setItem('userDetails', JSON.stringify(response.data.response))
              localStorage.setItem('isLogedIn', '1')
              resolve(response.data)
            } else {
              localStorage.clear()
              localStorage.setItem('isLogedIn', '0')
              console.log(JSON.stringify(response))
              reject(response.data)
            }
          }, function error (response) {
            localStorage.clear()
            localStorage.setItem('isLogedIn', '0')
            console.log(JSON.stringify(response))
            reject(response.data)
          })
        })
      },
      logOut: function () {
        $http({
          method: 'POST',
          url: appConfig.BASE_URL + 'userSessionLogout',
          data: { 'user_id': $rootScope.userDetails.user_id }
        }).then(function success (response) {
          if (response.data.status == 1) {
            localStorage.clear()
            localStorage.setItem('isLogedIn', '0')
          } else {
          }
        }, function error (response) {})
        return true
      },

      getUserDetails: function () {
        return JSON.parse(localStorage.getItem('userDetails')) || null
      }

    }
  }
})();

(function() {
    'use strict';

    angular.module('nagarpalika')
        .factory('translations', ['$timeout', '$q' ,translationsConfig]);

    function translationsConfig($timeout, $q) {
        return function (/*options*/) {
            var deferred = $q.defer();

            var translations = {
                GLOBAL: {
                    CREATE: {
                        SUCCESS: '{{type}} was created successfully!'
                    },
                    DELETE: {
                        SUCCESS: '{{type}} was deleted successfully!'
                    },
                    UPDATE: {
                        SUCCESS: '{{type}} was updated successfully!'
                    }
                },
                ACTIONTRACKER: {
                    CONFIRM_ROLLBACK: 'Are you sure you want to rollback this action? This will apply a change, but not the update. You will need to click "Update" to save the change(s).'
                }
            };

            $timeout(function() {
                deferred.resolve(translations);
            }, 1000);

            return deferred.promise;
        };
    }
})();
(function() {
    'use strict';

    angular.module('nagarpalika')
        .factory('config', [config]);

    function config() {
        var APP = APP || {};
        APP.localImgPath = "assets/images/"
        var host = (location.host.indexOf(':') !== -1) ? location.host.substring(0, location.host.indexOf(':')) : location.host;
        var apiUrl = location.protocol + '//' + host + '/api';

        var config = {
            apiUrl: apiUrl,
            appToken: {
                appId: 1,
                apiToken: 'eyJpdiI6IjM2SnRKY2hBVysxdk51aFp1eXJ2b2c9PSIsInZhbHVlIjoiMDNPU0JVT2Y0ekVOUGQ3bldkaG9VUjhPTEdQeUR5dnU0VHlLUUJ3aU1nZz0iLCJtYWMiOiJlYmU4YTA4MjA4NmIyNTRiNzZmMTMyYTRlYTk4ODUzYzE5NTdjNWVkY2ZiYjMyMGM5NWY3ODgyZDczY2U5OGRhIn0=',
                appIdKey: 'appId',
                apiTokenKey: 'apiToken'
            }
        };

        return config;
    }
})();
(function() {
    'use strict';

    angular
        .module('nagarpalika')
        .controller('MotherController', ['$scope','$mdSidenav','mainMenu',MotherController]);

    /** @ngInject */
    function MotherController($scope,$mdSidenav,mainMenu) {
        var vm = this;
        $scope.menuInfo = [];
        mainMenu.menuService()
        .then(function (res) {
          $scope.menuInfo = res;
        });


        $scope.toggleSidenav = function () {
         //console.log('toggleSidenav');
         $mdSidenav('nav').toggle();
        };


    }
})();

(function() {
  'use strict';

  angular.module('nagarpalika').run(['$rootScope',runBlock]);

  /** @ngInject */
  function runBlock($rootScope) {
    $rootScope.$on('$stateChangeSuccess', 
    function(event, toState, toParams, fromState, fromParams){
     // window.scrollTo(0, 0);  
      angular.element('body,html').animate({scrollTop: 0}, 800);
    })
  }

})();

(function () {
    'use strict';

    angular
        .module('nagarpalika')
        .config(['$stateProvider', '$urlRouterProvider','$locationProvider', 'appConfig' ,routerConfig]);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $locationProvider,appConfig) {
        $stateProvider
            .state('main', {
                url: '/',
                templateUrl: appConfig.templateUrl + 'main/main.html',
                controller: 'homeController',
                controllerAs: 'main'
            })
            .state('about', {
                url: '/about',
                templateUrl: appConfig.templateUrl + 'about/about.html',
                controller: 'AboutController',
                controllerAs: 'about'
            })
            .state('services', {
                url: '/services',
                templateUrl: appConfig.templateUrl + 'services/services.html',
                controller: 'ServicesController',
                controllerAs: 'services'
            })
            .state('development', {
                url: '/development',
                templateUrl: appConfig.templateUrl+ 'development/development.html',
                controller: 'DevelopmentController',
                controllerAs: 'development'
            })
            .state('rti', {
                url: '/rti',
                templateUrl: appConfig.templateUrl+ 'rti/rti.html',
                controller: 'RtiController',
                controllerAs: 'rti'
            })
             .state('news', {
                url: '/news',
                templateUrl: appConfig.templateUrl+ 'news/news.html',
                controller: 'NewsController',
               controllerAs: 'news'
            })
              .state('information', {
                url: '/information',
                templateUrl: appConfig.templateUrl+ 'information/information.html',
                controller: 'InfoController',
                controllerAs: 'info'
            })
             .state('gallery', {
                url: '/gallery',
                templateUrl: appConfig.templateUrl+ 'gallery/gallery.html',
                controller: 'GalleryController',
                controllerAs: 'gallery'
            })
            .state('downloads', {
                url: '/downloads',
                templateUrl: appConfig.templateUrl+ 'downloads/downloads.html',
                controller: 'DownController',
                controllerAs: 'downloads'
            })
            .state('serviceslist', {
                url: '/serviceslist/:serviceid',
                templateUrl: appConfig.templateUrl+ 'serviceslist/serviceslist.html',
                controller: 'ServiceslistController',
                controllerAs: 'sl'
            })
            .state('newslist', {
                url: '/newslist/:newsid',
                templateUrl: appConfig.templateUrl+ 'newslist/newslist.html',
                controller: 'NewslistController',
                controllerAs: 'nl'
            })
            .state('contact', {
                url: '/contact',
                templateUrl: appConfig.templateUrl+ 'contact/contact.html',
                controller: 'ContactController',
                controllerAs: 'contact'
            });

            

        $urlRouterProvider.otherwise('/');

        $locationProvider.html5Mode(true);
    }

})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('nagarpalika')
    .constant('appConfig', {
      RecptchaKey:'6LcuLS4UAAAAAC5itBw-FJtRwq0UM30wsvxDO9mt',
      BASE_URL: 'http://nagarparishadshahpurburhanpur.in/nagarpalikaapi/',
      ADMIN_EMAIL: '',
      localImgPath: 'assets/images/',
      templateUrl:'app/pages/',
      componentUrl:'app/components/'

    });

})();

(function() {
  'use strict';

  angular
    .module('nagarpalika')
    .config(['$logProvider','$translateProvider','$mdThemingProvider',config]);

  /** @ngInject */
  function config($logProvider, $translateProvider,$mdThemingProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Load translations
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translateProvider.useLoader('translations');
    // theme
    $mdThemingProvider.theme('default').primaryPalette('pink').accentPalette('orange');

  }

})();

angular.module("soccajoeys").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/devwork/devwork.html","<div class=develop_sect_h><div class=title_3><h1><span>Development</span> Work</h1></div><div class=row><div class=col-md-4 ng-repeat=\"dev in dw.devcont\"><div class=work_develp_sect><div class=work_de_img><img ng-src=\"{{ dev.image }}\" class=img-responsive alt=\"Washed Out\"><h3>{{ dev.pname }}</h3></div><div class=caption><p>{{ dev.details }}</p></div></div></div></div></div>");
$templateCache.put("app/components/follow-us/followus.html","<div class=follow_us><h3>follow us</h3><ul><li><a href=# title=\"follow us on facebook\"><span class=\"fa fa-facebook\"></span></a></li><li><a href=# title=\"follow us on instagram\"><span class=\"fa fa-instagram\"></span></a></li><li><a href=# title=\"follow us on youtube\"><span class=\"fa fa-youtube\"></span></a></li></ul></div>");
$templateCache.put("app/components/footer/footer.html","<footer id=footer class=footer_sec><div class=footer_top><div class=container><div class=row><div class=col-sm-3><div class=footer_widget_sect><h3 class=footer_widget_title>Important Links</h3><ul class=footer_links><li ng-repeat=\"links in fc.flink\"><a ui-sref={{links.url}}>{{links.name}}</a></li></ul></div></div><!-- <div class=\"col-sm-3\">\n          <div class=\"footer_widget_sect\">\n            <h3 class=\"footer_widget_title\">Quick Link</h3>\n            <ul class=\"footer_links\">\n              <li ng-repeat=\"qlinks in fc.qlink\">\n                <a href=\"#\">{{qlinks.name}} </a>\n              </li>\n            </ul>\n          </div>\n        </div> --><div class=col-sm-3><div class=footer_widget_sect><h3 class=footer_widget_title>Quick Links</h3><ul class=footer_links><li ng-repeat=\"mlinks in fc.mlink\" ng-if=\"$index<=3\"><a ui-sref={{mlinks.state}}>{{mlinks.text}}</a></li></ul></div></div><div class=\"col-sm-offset-2 col-sm-4\"><div class=footer_widget_sect><h3 class=footer_widget_title>Contact Us</h3><ul class=footer_address><li ui-sref-active=active><i class=\"fa fa-home\" aria-hidden=true></i> {{fc.contdata[0].cityname}} {{fc.contdata[0].state}}</li><li ui-sref-active=active></li><li ui-sref-active=active><i class=\"fa fa-phone\" aria-hidden=true></i>Phone: {{fc.contdata[0].phone}}</li><li ui-sref-active=active><i class=\"fa fa-envelope-o\" aria-hidden=true></i>Email: {{fc.contdata[0].email}}</li></ul></div></div></div></div></div><div class=footer_bottom><div class=container><div class=\"col-sm-4 pull-left\" style=color:white>&copy {{fc.links[3].name}} {{fc.links[3].link}}</div><div class=col-sm-4></div><div class=\"col-sm-4 social-icons-tab\" style=color:white><ul class=\"footer_socail_icon pull-right\"><li><a href={{fc.links[0].link}} target=_blank><i class=\"fa fa-facebook\"></i></a></li><li><a href={{fc.links[1].link}} target=_blank><i class=\"fa fa-google\"></i></a></li><li><a href={{fc.links[2].link}} target=_blank><i class=\"fa fa-twitter\"></i></a></li></ul></div></div></div></footer>");
$templateCache.put("app/components/header/header.html","<md-content><div class=top-bar-dark><div class=container><div class=row><div class=col-sm-4><a ng-click=hc.toggleMenu() class=\"responsive_toogle_bars hidden-lg hidden-md hidden-sm\"><span></span><span></span><span></span></a><ul class=h_top_links><li class=home_link><a ui-sref=main><span class=\"fa fa-home\"></span></a></li><li class=facebook_icon><a href={{hc.links[0].link}} target=_blank><span class=\"fa fa-facebook\"></span></a></li><li class=google_icon><a href={{hc.links[1].link}} target=_blank><span class=\"fa fa-google\"></span></a></li><li class=twitter_icon><a href={{hc.links[2].link}} target=_blank><span class=\"fa fa-twitter\"></span></a></li><li><span class=current_time>{{hc.datetoday | date:\'medium\'}}</span></li></ul></div><div class=\"col-sm-8 text-right hidden-xs\"><ul class=top_right_links><!-- <li><a href=\"#\">Screen Reader Access</a></li> --><li><a href=#>Skip to main content</a></li><li><a href=#>Site map</a></li><!-- <li><a href=\"#\">Hindi</a></li>\n            <li><a href=\"#\">English</a></li> --></ul></div></div></div></div></md-content><md-content class=main_header><div class=container><div class=row><div class=\"col-lg-3 col-md-3 col-sm-4\"><span class=logo_sect><img ng-src={{hc.logoimage[0].image}} alt=\"Nagar Palika Logo\" class=img-responsive></span></div><div class=\"col-lg-9 col-md-9 col-sm-8\"><div class=\"media_profile_sect1 pull-right\" ng-repeat=\"memitems in hc.members\"><div class=media-left><img class=\"media-object img-circle\" src={{memitems.image}}></div><div class=media-body><h4 class=media-heading>{{memitems.name}}</h4><p>{{memitems.designation}},{{memitems.desgon}}</p></div></div></div></div></div></md-content><nav class=\"navbar navbar_section\"><div class=container><div class=clearfix></div><ul class=\"nav navbar-nav hidden-xs\"><li data-ng-repeat=\"menuitems in hc.menuInfo\" ui-sref-active=active><a ui-sref={{menuitems.state}} title={{menuitems.text}}><span>{{menuitems.text}}</span></a></li></ul></div><!-- /.container-fluid --></nav><header id=header class=header_sec></header>");
$templateCache.put("app/components/imagegallery/imagegallery.html","<img src={{params.image}} class=img-thumbnail width=550>");
$templateCache.put("app/components/implinks/implinks.html","<div class=side_widgets><h2 class=title_2>Important <span>Links</span></h2><ul class=important_links_list><li ng-repeat=\"link in impl.links\"><a href=\"{{ link.link }}\" target=_blank><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> {{ link.name }}</a></li></ul></div>");
$templateCache.put("app/components/latestnews/latestnews.html","<div class=latest_news_sect><h2 class=title_2>Latest <span>News</span> <a ui-sref=news class=\"pull-right view_all_link1\">View All</a></h2><ul class=h_latest_news><li ng-repeat=\"item in ln.listnews\" ng-if=\"$index<=2\" ui-sref=newslist({newsid:item.id}) style=cursor:pointer><div class=news_block><div class=media-left><a href=#><img class=media-object ng-src=\"{{ item.image }}\" class=md-avatar></a></div><div class=media-body><h4 class=media-heading>{{ item.title }}</h4><p>{{ item.content1 }}</p><span class=news_date_1>{{ item.ndate }}</span></div></div></li></ul></div>");
$templateCache.put("app/components/newsletter/newsletter.html","<div class=newsletter><h3>Sign up for our Newsletter</h3><div class=newsletter_form><form role=form><div class=form-group><input type=email placeholder=\"Enter Email Here\" class=form-control></div><div class=form-group><input type=submit value=Subscribe class=\"btn btn-primary\"></div></form></div></div>");
$templateCache.put("app/components/otherlinks/otherlinks.html","<div class=otherlinks_sect><h2 class=title_2>Other <span>Information</span></h2><ul class=other_links_listing><li ng-repeat=\"iteam in ol.otherlinks\" ng-if=\"$index>=7\"><a ui-sref=serviceslist({serviceid:iteam.id})><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> {{ iteam.name }}</a></li></ul></div>");
$templateCache.put("app/components/services/services.html","<div class=h_service_tab_block><div class=container><div class=title_3><h1><span>Citizen</span> Services</h1></div></div></div><div class=servic_tabes_sect><div class=container><ul class=service_tabs_list><li class=text-center ng-repeat=\"tab in serve.servtab\" ng-if=\"$index<=6\"><a ui-sref=serviceslist({serviceid:tab.id})><span class=serv_tab_avatar><img src={{tab.image}}></span><b>{{tab.name}}</b></a></li><div class=clearfix></div></ul></div></div>");
$templateCache.put("app/components/slider/slider.html","<div class=slider_wrapper><div class=slider_body><slick autoplay infinite=true speed=300 touch-move=true responsive=breakpoints slides-to-show=1 slides-to-scroll=1><div class=slick-item ng-repeat=\"data in slider.sliderImg\"><img ng-src=\"{{slider.localimagesPath + \'slider-images/\' + data.img}}\" alt=img style=\"width:100%; height:100%\"></div></slick></div></div>");
$templateCache.put("app/pages/about/about.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>About Us</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>About Us</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><p>{{about.aboutcontent[0].content1}}</p><p>{{about.aboutcontent[0].content2}}</p><div><ul class=bullets_1><li ng-repeat=\"p in about.aboutcontent[0].points\">{{p}}</li></ul></div><div class=officer_message_desk style=margin-top:50px><h4>From the {{about.mmessage[0].heading}}\'s Desk</h4><!-- <div class=\"media-left\">\n            <div class=\"avata_image_sect\">\n              <img class=\"media-object\" src=\"../assets/images/avatar_img1.png\">\n              <h4 class=\"media-heading\"> {{about.mmessage[0].heading}} {{about.mmessage[0].heading1}} <br>Mayor, Municipal Corporation</h4>\n            </div>\n          </div> --><div class=media-body><p>{{about.mmessage[0].content1}}</p><p>{{about.mmessage[0].content2}}</p></div></div><div class=officer_message_desk style=margin-top:50px><h4>{{about.cmessage[0].heading}} Message</h4><!-- <div class=\"media-left\">\n              <div class=\"avata_image_sect\">\n                <img class=\"media-object\" src=\"../assets/images/avatar_img1.png\">\n                <h4 class=\"media-heading\"> {{about.mmessage[0].heading}} {{about.mmessage[0].heading1}} <br>Mayor, Municipal Corporation</h4>\n              </div>\n            </div> --><div class=media-body><p>{{about.cmessage[0].content1}}</p><p>{{about.cmessage[0].content2}}</p></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/contact/contact.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Contact Us</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Contact Us</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><div class=\"palika_map margin20\"><iframe src=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3703.8175112376002!2d75.61548471494635!3d21.825980685571988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd885d9b3a55143%3A0xa92581f7cb056d5c!2sNagar+Palika+Khargone!5e0!3m2!1sen!2sin!4v1502874885757\" width=100% height=180 frameborder=0 style=border:0 allowfullscreen></iframe></div><h4 class=title_5>Write to Us</h4><p><b>Fill all the necessary fields to send a message.</b></p><form ng-submit=contact.contactForm()><div class=\"form_section1 row margin30\"><div class=col-md-6><div class=form-group><label>Subject</label><input type=text class=form-control name=subject ng-model=contact.formData.subject required></div></div><div class=col-md-6><div class=form-group><label>Your Name</label><input type=text class=form-control name=name ng-model=contact.formData.name required></div></div><div class=col-md-6><div class=form-group><label>Your Email</label><input type=email class=form-control name=email ng-model=contact.formData.email required></div></div><div class=col-md-6><div class=form-group><label>Phone</label><input type=text class=form-control name=phone ng-model=contact.formData.phone required></div></div><div class=col-md-12><div class=form-group><label>Your Message</label><textarea class=form-control rows=4 name=message ng-model=contact.formData.message required></textarea></div></div><div class=col-md12><div class=form-group><div class=col-md-12><div class=form_capture><span class=capture_code>{{ contact.rNum }}</span> <input type=text name=captcha placeholder=\"Enter Code\" required ng-model=contact.formData.captcha class=form-control> <button type=button ng-click=contact.getRandomSpan() class=refresh-btn><img src=assets/images/refresh.png width=20></button></div></div></div></div><div class=col-md-12><div class=form-group><md-checkbox ng-model=contact.formData.cbox required aria-label=\"Checkbox 1\">Verify me!</md-checkbox></div></div><div class=col-md-6><div class=form-group><input type=submit class=\"btn btn-lg submit_btn1\" value=submit></div></div></div></form><div class=row><div class=col-md-6><h4 class=title_5>Contact Details</h4><ul class=contact_addres><li><i class=\"fa fa-map-marker\"></i> {{contact.contdata[0].cityname}} {{contact.contdata[0].state}}</li><li><i class=\"fa fa-phone\"></i> {{contact.contdata[0].phone}}</li><li><i class=\"fa fa-envelope\"></i>{{contact.contdata[0].email}}</li></ul></div><div class=col-md-6><h4 class=title_5>JOIN US</h4><ul class=contactus_socil><li><a href={{contact.links[0].link}} target=_blank><span class=\"fa fa-facebook\"></span></a></li><li><a href={{contact.links[1].link}} target=_blank><span class=\"fa fa-google\"></span></a></li><li><a href={{contact.links[2].link}} target=_blank><span class=\"fa fa-twitter\"></span></a></li></ul></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/development/development.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>City Development Programs</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>City Development Programs</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><div ng-repeat=\"devvalue in development.devprg\"><div class=row><div class=row style=padding-top:25px><div class=col-md-12><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> {{devvalue.pname}}</h2></div></div><div class=row><div class=col-md-12><div class=col-md-4><img ng-src=\"{{ devvalue.image }}\" class=img-responsive alt=\"Washed Out\"></div><div class=col-md-8><p style=text-align:justify>{{devvalue.details}}</p></div></div></div></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/downloads/downloads.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Download</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Download</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><h4 class=margin20>Downloads Important Documents</h4><ul class=downloads_listing><li ng-repeat=\"diteams in downloads.dwiteams\"><a href={{diteams.image}} target=_blank>{{diteams.title}}, {{diteams.description}}</a></li><!-- <li><a href=\"#\">Urban Development SAF Form</a></li>\n          <li><a href=\"#\">Application form for widow and old and handicap person</a></li>\n          <li><a href=\"#\">Application form for Residence</a></li>\n          <li><a href=\"#\">Application form for below of poverty line</a></li>\n          <li><a href=\"#\">Application form for Agreement</a></li>\n          <li><a href=\"#\">Application form for Financial And development for SC- ST</a></li>\n          <li><a href=\"#\">Application form for Self Employment</a></li>\n          <li><a href=\"#\">Application form for Training</a></li>\n          <li><a href=\"#\">Marriage Registration Act and Related Document List</a></li>\n          <li><a href=\"#\">Building Permission Application Form</a></li>\n          <li><a href=\"#\">Birth & Death Application Form</a></li>\n          <li><a href=\"#\">Pet Dog Registration Form</a></li>\n          <li><a href=\"#\">Trade License Form</a></li>\n          <li><a href=\"#\">Application Form for Contractors</a></li>\n          <li><a href=\"#\">Grievance Form</a></li>\n          <li><a href=\"#\">Health Application Form</a></li>\n          <li><a href=\"#\">Death Registration Form</a></li>\n          <li><a href=\"#\">Birth Registration Form</a></li>\n          <li><a href=\"#\">Still Birth Registration Form left</a></li> --></ul></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/gallery/gallery.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Gallery</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Gallery</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><div class=col-md-12><div class=col-md-4 ng-repeat=\"imgdata in gallery.galdata\" style=margin-top:15px><h5 style=padding:5px>{{imgdata.title}}</h5><img src={{imgdata.image}} class=\"img-responsive img-thumbnail\" ng-click=gallery.showImage($event,imgdata.image)></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/information/information.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Department Information</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Department Information</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><!-- <p>The main objective of Nagar Palika Parisad Ranapur is provide efficient, effective, equitable, citizen responsive, financially sustainable and transparent, quality service to its citizens. Nagar Palika Parisad Ranapur provide and facilitates several services for the citizens of Ranapur. The record of birth and death rates with Municipal Corporation helps a citizen in different ways. With the help of birth or death certificate, one can get numerous job opportunities or can easily make their passport and can even claim the deceased bank savings. Apart from this aspect of MC\'s service, development plans are meant to carve out a better and planned city.</p>\n      <p>E-governance in municipalities focuses on improving national element of citizen services through defining service levels and outcomes; facilitating interactive interaction between local government, citizens and other stakeholders; improving quality of internal operation of local government; enhancing transparency and accountability; enhancing citizen interface and improving service delivery to citizens. </p>\n      <p>The first priority of HNP is to provide basic civic services to its citizen and for appropriate implementation the corporation has divided into various departments.</p>\n      <p>We have following departments to provide various services to the citizens of Ranapur.</p> --><div><table class=\"table table-bordered infor_table1\"><thead><tr><th>Officer Name</th><th>Designation</th><th>Work</th><th>Contact</th></tr></thead><tbody><tr ng-repeat=\"depinfos in info.depinfo\"><td>{{depinfos.name }}</td><td>{{depinfos.designation}}</td><td>{{depinfos.other}}</td><td>{{depinfos.contact}}</td></tr></tbody></table></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n          <other-links></other-links>\n        </div> --></div></div></div></div>");
$templateCache.put("app/pages/main/main.html","<div id=main class=main_wrapper><div class=main_sec3><app-slider></app-slider></div><div class=container><div class=row><div class=col-md-4><img src=assets/images/roadconstruction.jpg class=img-responsive></div><div class=col-md-8><h2 class=title_1><b><span>{{main.resdata[0].heading }}</span> {{main.resdata[0].heading1 }}</b></h2><p>{{main.resdata[0].content1 }}</p><p>{{main.resdata[0].content2 }}</p><a ui-sref=about class=\"btn red_btn_1\">Read more</a></div></div></div><div class=padding-40></div><services-tab></services-tab><div class=padding-40></div><div class=news_and_links_sect><div class=container><div class=row><div class=col-md-6><latest-news></latest-news></div><div class=col-md-6><imp-links></imp-links><!--<other-links></other-links>--></div></div></div></div><div class=container><dev-work></dev-work></div></div>");
$templateCache.put("app/pages/news/news.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>News And Events</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>News</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><latest-news></latest-news></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><other-links></other-links></div></div></div></div></div>");
$templateCache.put("app/pages/newslist/newslist.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Latest News</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Latest News</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><div ng-repeat=\"devvalue in nl.aboutcontent\"><div class=row><div class=row style=padding-top:25px><div class=col-md-12><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> {{devvalue.title}} - {{devvalue.ndate}}</h2></div></div><div class=row><div class=col-md-12><div class=col-md-3><img ng-src=\"{{ devvalue.image }}\" width=150 alt=\"News Image\"></div><div class=col-md-9><p style=text-align:justify>{{devvalue.content1}}</p><p style=text-align:justify>{{devvalue.content2}}</p></div></div></div></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n            <other-links></other-links>\n          </div> --></div></div></div></div>");
$templateCache.put("app/pages/rti/rti.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>RTI</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>RTI</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><div><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> {{rti.rtiinfo[0].title}}</h2><!-- <p>{{devvalue.content}}</p>\n          <p>{{devvalue.content2}}</p>\n          <p>{{devvalue.content3}}</p> --><p>{{rti.rtiinfo[0].content}}</p><ul class=bullets_1><li ng-repeat=\"p in rti.rtiinfo[0].points\">{{p}}</li></ul></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n            <other-links></other-links>\n          </div> --></div></div></div></div>");
$templateCache.put("app/pages/services/services.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>Citizen Services</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>Citizen Services</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row><div class=col-md-9><ul class=citizen_serv_listing><li ng-repeat=\"tab in services.servtab\"><div class=citize_s_block><a ui-sref=serviceslist({serviceid:tab.id})><span><img class=img-responsive src={{tab.image}}></span><h5>{{tab.name}}</h5></a></div></li></ul></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><div class=sidebar_sect><other-links></other-links></div></div></div></div></div>");
$templateCache.put("app/pages/serviceslist/serviceslist.html","<div class=\"inner_top_sect margin40\"><div class=container><div class=row><div class=col-md-4><h3 class=inner_p_title1>{{sl.aboutcontent[0].name}}</h3></div><div class=col-md-8><ol class=\"breadcrumbs pull-right\"><li><a href=#>Home</a></li><li class=active>{{sl.aboutcontent[0].name}}</li></ol></div></div></div></div><div class=\"inner_page_section margin40\"><div class=container><div class=row ng-repeat=\"depinfos in sl.aboutcontent\"><div class=col-md-9><!-- <div class=\"col-md-12 text-center\" style=\"background-color:red;\">\n          <img src=\"{{depinfos.image}}\" alt=\"citizen services\" class=\"img-responsive\">\n        </div> --><div class=col-md-12><div class=\"row col-md-12\"><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> Department Information</h2></div><div class=\"row col-md-12\"><table class=\"table table-bordered infor_table1\"><thead><tr><th>Officer Name</th><th>Contact Person</th><th>Contact Numbers</th></tr></thead><tbody><tr><th>{{depinfos.nameperson }}</th><td>{{depinfos.link}}</td><td>{{depinfos.contactperson}}</td></tr></tbody></table></div><div class=\"row col-md-12\"><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> How to apply ?</h2></div><div class=\"row col-md-12\"><p>{{depinfos.details}}</p></div><div class=\"row col-md-12\"><h2 class=inerr_title_1><i class=\"fa fa-angle-double-right\" aria-hidden=true></i> Required Documents</h2></div><div class=\"row col-md-12\"><p>{{depinfos.impdocs}}</p></div></div></div><div class=col-md-3><div class=sidebar_sect><imp-links></imp-links></div><div class=sidebar_sect><latest-news></latest-news></div><!-- <div class=\"sidebar_sect\">\n            <other-links></other-links>\n          </div> --></div></div></div></div>");}]);